import { combineReducers } from 'redux'

import package_json from '../../package.json'

import activeAudioReducer from './activeAudio/reducers'
import activeConversationReducer from './activeConversation/reducers'
import availabilitiesReducer from './availabilities/reducers'
import companyReducer from './company/reducers'
import conversationsReducer from './conversations/reducers'
import featuresReducer from './features/reducers'
import expandedReducer from './expanded/reducers'
import permissionsReducer from './permissions/reducers'
import permissionsExtraReducer from './permissions_extra/reducers'
import preferencesReducer from './preferences/reducers'
import profilesReducer from './profiles/reducers'
import keywordReducer from './keyword/reducers'
import rolesReducer from './roles/reducers'
import userReducer from './user/reducers'
import signalrReducer from './signalR/reducers'
import insightReducer from './insights/reducers'
import historyReducer from './historyConversation/reducers'
import shortcutReducer from './shortcuts/reducers'
import faqReducer from './faq/reducers'
import scriptReducer from './script/reducers'
import myContentReducer from './myContent/reducers'
import metricsReducer from './goals/reducers'
import userConfigReducer from './userConfiguration/reducers'
import usabilityReducer from './usability/reducers'
import widgetReducer from './widgets/reducers'
import tabReducer from './tabs/reducers'
import ticketSetReducer from './ticketGallery/reducers'
import tabulationGalleryReducer from './tabulationGallery/reducers'
import undockReducer from './undock/reducers'
import generalInfoReducer from './generalInformation/reducers'
import galleryOpenReducer from './gallery/reducers'
import favoriteMessagesReducer from './favoriteMessages/reducers'
import usefulLinksReducer from './usefulLinks/reducers'
import userPreferencesReducer from './userPreferences/reducers'
import dockReducer from './dock/reducers'
import tabListReducer from './tabList/reducers'
import changeStatusReducer from './changeStatus/reducers'
import accordionReducer from './ticket/reducers'
import tabValueReducer from './tabValue/reducers'
import favoriteScriptsReducer from './favoriteScript/reducers'
import consumerTicketsReducer from './consumerTickets/reducers'
import interactionsReducer from './interactions/reducers'
import manageControlReducer from './manageControl/reducers'
import summaryReducer from './summaries/reducers'

const appReducer = combineReducers({
  activeAudio: activeAudioReducer,
  activeConversation: activeConversationReducer,
  availabilities: availabilitiesReducer,
  company: companyReducer,
  conversations: conversationsReducer,
  expanded: expandedReducer,
  faq: faqReducer,
  script: scriptReducer,
  favoriteMessages: favoriteMessagesReducer,
  features: featuresReducer,
  generalInformation: generalInfoReducer,
  metrics: metricsReducer,
  history: historyReducer,
  insights: insightReducer,
  myContent: myContentReducer,
  permissions: permissionsReducer,
  permissions_extra: permissionsExtraReducer,
  preferences: preferencesReducer,
  keyword: keywordReducer,
  profiles: profilesReducer,
  roles: rolesReducer,
  shortcuts: shortcutReducer,
  signalR: signalrReducer,
  tabList: tabListReducer,
  tabs: tabReducer,
  ticketGallery: ticketSetReducer,
  tabulationGallery: tabulationGalleryReducer,
  usability: usabilityReducer,
  usefulLinks: usefulLinksReducer,
  user: userReducer,
  userConfiguration: userConfigReducer,
  userPreferences: userPreferencesReducer,
  widgets: widgetReducer,
  undock: undockReducer,
  dock: dockReducer,
  galleryOpen: galleryOpenReducer,
  changeStatus: changeStatusReducer,
  accordionValue: accordionReducer,
  tabValue: tabValueReducer,
  favoriteScripts: favoriteScriptsReducer,
  consumerTickets: consumerTicketsReducer,
  interactions: interactionsReducer,
  manageControl: manageControlReducer,
  summaries:summaryReducer,
  version: () => package_json.version,
})

const rootReducer = (state, action) => {
  // Clear all data in redux store to initial.
  if (action.type === 'LOGOUT') state = undefined

  return appReducer(state, action)
}

export default rootReducer
